export default {
    "PROGRAM": {
        "PROGRAM": "Program",
        "NAME": "Név",
        "NAME_EN": "Angol név",
        "START": "Kezdete",
        "END": "Vége",
        "LOCATION": "Helyszín",
        "ARTIST": "Előadó",
        "DESCRIPTION": "Leírás",
        "LONG_DESCRIPTION": "Hosszabb leírás",
        "FILE": "Fájl",
        "STATUS": "Státusz",
        "SLUG": "URL",
        "IS_CHANGED": "Megváltozott",
        "CLONE": "Program másolása",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/program.js